import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { publicColors, publicContainerSx, publicFontFamily, publicHeroFontSx } from './publicTheme';

const painStats = [
    { stat: '???', label: 'Margem real por peça', sub: 'Quando o preço é no feeling' },
    { stat: '0%', label: 'Visibilidade de falhas', sub: 'Sem histórico por impressora' },
    { stat: 'Caos', label: 'Produção vs. vendas', sub: 'Planilha não cruza os dois' },
];

const Banner = () => (
    <Box
        id="top"
        component="section"
        sx={{
            bgcolor: publicColors.surface,
            borderBottom: `1px solid ${publicColors.border}`,
            pt: { xs: 14, md: 16 },
            pb: { xs: 8, md: 12 },
            fontFamily: publicFontFamily,
        }}
    >
        <Box sx={{ ...publicContainerSx, px: { xs: 2, md: 3 } }}>
            <Stack spacing={4} alignItems="center" textAlign="center">
                <Typography
                    component="p"
                    sx={{
                        fontFamily: publicFontFamily,
                        fontSize: { xs: '0.8rem', sm: '0.875rem' },
                        fontWeight: 700,
                        letterSpacing: '0.14em',
                        textTransform: 'uppercase',
                        color: publicColors.primary,
                    }}
                >
                    Gestão de produção e vendas 3D
                </Typography>

                <Box sx={{ maxWidth: 920 }}>
                    <Typography
                        component="h1"
                        sx={{
                            ...publicHeroFontSx,
                            fontWeight: 800,
                            fontSize: { xs: '2.75rem', sm: '3.5rem', md: '4.25rem', lg: '4.75rem' },
                            color: publicColors.ink,
                            mb: 1,
                        }}
                    >
                        Você não sabe
                    </Typography>
                    <Typography
                        component="p"
                        aria-hidden
                        sx={{
                            ...publicHeroFontSx,
                            fontWeight: 800,
                            fontSize: { xs: '2.75rem', sm: '3.5rem', md: '4.25rem', lg: '4.75rem' },
                            color: publicColors.danger,
                            mb: 2,
                        }}
                    >
                        se está lucrando.
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: publicFontFamily,
                            fontSize: { xs: '1.125rem', md: '1.35rem' },
                            fontWeight: 500,
                            color: publicColors.inkMuted,
                            lineHeight: 1.65,
                            maxWidth: 680,
                            mx: 'auto',
                        }}
                    >
                        Sem métricas, você chuta preço, perde filamento em retrabalho e aceita pedido
                        que não paga a operação. O Acompanha 3D centraliza{' '}
                        <Box component="span" sx={{ color: publicColors.ink, fontWeight: 700 }}>
                            produção, custos e vendas
                        </Box>{' '}
                        para decidir com estatística — não com planilha solta e com fórmulas que não refletem a sua realidade..
                    </Typography>
                </Box>

                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    justifyContent="center"
                    sx={{ pt: 1 }}
                >
                    <Button
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        component="a"
                        href="#registrationForm"
                        sx={{
                            fontFamily: publicFontFamily,
                            bgcolor: publicColors.primary,
                            fontWeight: 700,
                            fontSize: '1rem',
                            px: 4,
                            py: 1.5,
                            borderRadius: 1.5,
                            boxShadow: 'none',
                            '&:hover': { bgcolor: publicColors.primaryDark, boxShadow: 'none' },
                        }}
                    >
                        Parar de adivinhar — criar conta
                    </Button>
                    <Button
                        variant="outlined"
                        size="large"
                        component={RouterLink}
                        to="/calculator"
                        sx={{
                            fontFamily: publicFontFamily,
                            borderColor: publicColors.border,
                            borderWidth: 2,
                            color: publicColors.ink,
                            fontWeight: 700,
                            fontSize: '1rem',
                            px: 4,
                            py: 1.5,
                            borderRadius: 1.5,
                            '&:hover': {
                                borderColor: publicColors.primary,
                                borderWidth: 2,
                                bgcolor: publicColors.primarySoft,
                            },
                        }}
                    >
                        Simular preço agora
                    </Button>
                </Stack>

                <Grid container spacing={2} sx={{ pt: 4, maxWidth: 960 }}>
                    {painStats.map((item) => (
                        <Grid item xs={12} sm={4} key={item.label}>
                            <Box
                                sx={{
                                    p: 2.5,
                                    height: '100%',
                                    bgcolor: publicColors.surfaceAlt,
                                    border: `1px solid ${publicColors.border}`,
                                    borderRadius: 2,
                                    textAlign: 'center',
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: publicFontFamily,
                                        fontWeight: 800,
                                        fontSize: { xs: '1.75rem', md: '2rem' },
                                        color: publicColors.danger,
                                        letterSpacing: '-0.03em',
                                        lineHeight: 1,
                                        mb: 1,
                                    }}
                                >
                                    {item.stat}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: publicFontFamily,
                                        fontWeight: 700,
                                        fontSize: '0.95rem',
                                        color: publicColors.ink,
                                        mb: 0.5,
                                    }}
                                >
                                    {item.label}
                                </Typography>
                                <Typography variant="body2" sx={{ color: publicColors.inkSoft, lineHeight: 1.5 }}>
                                    {item.sub}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>

                <Typography
                    variant="body2"
                    sx={{
                        fontFamily: publicFontFamily,
                        color: publicColors.inkSoft,
                        maxWidth: 520,
                        pt: 1,
                        fontWeight: 500,
                    }}
                >
                    Dashboard · jobs · integração com impressoras · vendas · calculadora de margem
                </Typography>
            </Stack>
        </Box>
    </Box>
);

export default Banner;
